export default __webpack_public_path__ + "static/media/revicons.57fd05d4.ttf";